export default __webpack_public_path__ + "static/media/random-bingo.f6a8298a.png";